export const headerLists = {
  byPosition: [
    {
      label: 'Symbol',
      key: 'symbol',
      applyRounding: false,
    },
    {
      label: 'Side',
      key: 'side',
      applyRounding: false,
    },
    {
      label: 'PnL',
      key: 'pnl',
      applyRounding: true,
    },
    {
      label: '% PnL',
      key: 'percent_pnl',
      applyRounding: false,
    },
    {
      label: 'Cost',
      key: 'cost_basis',
      applyRounding: true,
    },
    {
      label: 'Qty.',
      key: 'quantity',
      applyRounding: false,
    },
    {
      label: 'Opened',
      key: 'date_acquired',
      applyRounding: false,
    },
    {
      label: 'Closed',
      key: 'date_exited',
      applyRounding: false,
    },
    {
      label: 'Setup',
      key: 'strategy',
      applyRounding: false,
    },
    {
      label: 'Details',
      key: 'strategyDescription',
      applyRounding: false,
    },
    {
      label: 'Template',
      key: 'tradePlanTemplate',
      applyRounding: false,
    },
    {
      label: 'Day',
      key: 'day',
      applyRounding: false,
    },
  ],
  bySymbol: [
    {
      label: 'Symbol',
      key: 'symbol',
      applyRounding: false,
    },
    {
      label: 'Direction',
      key: 'direction',
      applyRounding: false,
    },
    {
      label: 'PnL',
      key: 'pnl',
      applyRounding: true,
    },
    {
      label: '% PnL',
      key: 'percent_pnl',
      applyRounding: false,
    },
    {
      label: 'Cost',
      key: 'cost_basis',
      applyRounding: true,
    },
    {
      label: 'Trades',
      key: 'totalTrades',
      applyRounding: false,
    }
  ],
  byUnderlying: [
    {
      label: 'Symbol',
      key: 'symbol',
      applyRounding: false,
    },
    {
      label: 'Direction',
      key: 'direction',
      applyRounding: false,
    },
    {
      label: 'PnL',
      key: 'pnl',
      applyRounding: true,
    },
    {
      label: '% PnL',
      key: 'percent_pnl',
      applyRounding: false,
    },
    {
      label: 'Cost',
      key: 'cost_basis',
      applyRounding: true,
    },
    {
      label: 'Trades',
      key: 'totalTrades',
      applyRounding: false,
    }
  ],
  byTradePlan: [
    {
      label: 'Template',
      key: 'tradePlanTemplate',
      applyRounding: false,
    },
    {
      label: 'Setup',
      key: 'strategy',
      applyRounding: false,
    },
    {
      label: 'Direction',
      key: 'direction',
      applyRounding: false,
    },
    {
      label: 'PnL',
      key: 'pnl',
      applyRounding: true,
    },
    {
      label: '% PnL',
      key: 'percent_pnl',
      applyRounding: false,
    },
    {
      label: 'Cost',
      key: 'cost_basis',
      applyRounding: true,
    },
    {
      label: 'Trades',
      key: 'totalTrades',
      applyRounding: false,
    },
    {
      label: 'Day',
      key: 'day',
      applyRounding: false,
    },
  ],
  byTemplate: [
    {
      label: 'Template',
      key: 'tradePlanTemplate',
      applyRounding: false,
    },
    {
      label: 'Direction',
      key: 'direction',
      applyRounding: false,
    },
    {
      label: 'PnL',
      key: 'pnl',
      applyRounding: true,
    },
    {
      label: '% PnL',
      key: 'percent_pnl',
      applyRounding: false,
    },
    {
      label: 'Cost',
      key: 'cost_basis',
      applyRounding: true,
    },
    {
      label: 'Trades',
      key: 'totalTrades',
      applyRounding: false,
    }
  ],
  byDay: [
    {
      label: 'Day',
      key: 'day',
      applyRounding: false,
    },
    {
      label: 'Direction',
      key: 'direction',
      applyRounding: false,
    },
    {
      label: 'PnL',
      key: 'pnl',
      applyRounding: true,
    },
    {
      label: '% PnL',
      key: 'percent_pnl',
      applyRounding: false,
    },
    {
      label: 'Cost',
      key: 'cost_basis',
      applyRounding: true,
    },
    {
      label: 'Trades',
      key: 'totalTrades',
      applyRounding: false,
    }
  ]
};
